import { ConfirmSpeakerModal } from "./ConfirmSpeakerModal";

export default ConfirmSpeakerModal;
